module.exports = __webpack_public_path__ + "f82d9422360c0a738b4f57f1d21ca411.png";